import * as React from 'react'
import ContractIndividual from '../tabs/contracts/views/ContractIndividual'

export const DriverContractsPage = ({ match }) => {
  const { params } = match
  const { driverId, companyId } = params

  return (
    <section className="tw-h-full tw-w-full tw-flex tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden tw-px-5 tw-pb-4">
        <ContractIndividual companyId={companyId} driverId={driverId} />
    </section>
  )
}
